import React from 'react'
import {Icon} from '@chakra-ui/react'

const GoBackIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M15.9997 22.6666L9.33301 15.9999L15.9997 9.33324"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.33301 15.9999H23.333C24.296 15.9999 25.2496 16.1896 26.1394 16.5581C27.0291 16.9267 27.8375 17.4668 28.5185 18.1478C29.1994 18.8288 29.7396 19.6372 30.1081 20.5269C30.4767 21.4166 30.6663 22.3702 30.6663 23.3332C30.6663 24.2963 30.4767 25.2499 30.1081 26.1396C29.7396 27.0293 29.1994 27.8377 28.5185 28.5187C27.8375 29.1997 27.0291 29.7398 26.1394 30.1084C25.2496 30.4769 24.296 30.6666 23.333 30.6666H18.6663"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default GoBackIcon
